import { render } from "./CopyButton.vue?vue&type=template&id=bfb7fd6a&scoped=true"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"

import "./CopyButton.vue?vue&type=style&index=0&id=bfb7fd6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bfb7fd6a"

export default script